import { render, staticRenderFns } from "./TicketOwnerReadOnlyForm.vue?vue&type=template&id=b0db410e&"
import script from "./TicketOwnerReadOnlyForm.vue?vue&type=script&lang=js&"
export * from "./TicketOwnerReadOnlyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports